import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-select-modal',
  templateUrl: './chat-select-modal.component.html',
  styleUrls: ['./chat-select-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatSelectModalComponent implements OnInit {

  constructor() { }
  @Input() selectedValue: string | null = '';
  @Input() options: any = [];
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() key:string = '';
  @Output() selectionChanged = new EventEmitter<string | null>();

  searchTerm = '';
  filteredValues: any = [];

  ngOnInit(): void {
    this.filteredValues = this.options;
  }

  selectValue(value: string) {
    this.selectedValue = value;
    this.selectionChanged.emit(this.selectedValue);
  }

  filterValues() {
    this.filteredValues = this.options.filter((item: any) =>
      item[this.key].toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  close() {
    this.selectionChanged.emit(null);
  }
}
